module Main

open Elmish
open Elmish.React
open Elmish.Debug
open Elmish.HMR // keep state between reloads

Fable.Core.JsInterop.importAll "custom-event-polyfill/polyfill.js"

let init apiInfo arg =
    let (model, fx) = App.init apiInfo arg
    (model, fx |> List.map (App.perform model.ApiInfo))


let update msg model =
    let (model, fx) = App.update msg model
    (model, fx |> List.map (App.perform model.ApiInfo))

let routeUpdate routeOpt (model : App.Model) =
    let (page, fx) = App.routeUpdate routeOpt
    { model with Page = page }, fx |> List.map (App.perform model.ApiInfo)

// - - - - - - -  Is this right? - - - - - - -

open Fable.Core

// weird fable to js interop stuff
[<Emit("apiUrl")>]
let apiUrl : string = jsNative

let apiInfo = { ApiUrl = apiUrl }

// - - - - - - -  Is this right? - - - - - - -


Program.mkProgram (fun routeOpt -> init apiInfo routeOpt) update App.view
|> Program.withReactBatched "elmish-app"
#if DEBUG
|> Program.withConsoleTrace
// debugger is off by default, because it requires external tools or it will error on console
// |> Program.withDebugger
#endif
|> Program.toNavigable Route.fromLocation routeUpdate
|> Program.run

